import { AppBar, Box, IconButton, Link, useMediaQuery, useTheme } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTranslation } from "react-i18next";
import { tpTheme, TrainingpeaksVirtual } from "@trainingpeaks/designtokens";
import TPLogoDesktop from "@components/Assets/TPLogoDesktop";
import TPLogoMobile from "@components/Assets/TPLogoMobile";
import UserAvatarIcon from "@components/Nav/UserAvatarIcon";
import { getTopNavRoutes } from "@constants/topNavRoutes";

const tpVirtualUrl = "https://www.trainingpeaks.com/virtual/";

interface HeaderProps {
  onMenuClick?: () => void;
}

const Header = ({ onMenuClick }: HeaderProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isNarrow = useMediaQuery(theme.breakpoints.down("sm"));

  const topNavRoutes = getTopNavRoutes(t);

  return (
    <AppBar
      data-testid="header-component"
      position="sticky"
      variant={"topNav" as never}
      className="z-[1201]"
    >
      <div className="z-10 min-w-full pb-0 text-center h-10 flex items-center justify-between">
        <div className="pl-2 flex items-center gap-2">
          {isMobile && onMenuClick && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={onMenuClick}
              aria-label="open navigation"
              data-testid="menu-button"
              className="mr-2"
            >
              <MenuIcon />
            </IconButton>
          )}
          {isNarrow ? <TPLogoMobile /> : <TPLogoDesktop />}
        </div>
        {!isMobile && !isNarrow &&
          <div className="pt-2 flex justify-items-start justify-around items-center">
            {topNavRoutes.map((route, index) => (
              <Link
                className="flex items-center justify-between sm:pr-3 sm:pl-3 sm:mr-2 sm:pb-2 sm:ml-2 sm:h-8"
                key={index}
                href={route.route}
                variant={"topNav" as never}
                underline="none"
              >
                {route.title}
              </Link>
            ))}
          </div>
        }
        <div
          className={`${!isMobile ? "w-48" : "w-20"} mr-4 flex justify-end`}
        >
          <UserAvatarIcon />
          {/* Move this box into its own TPVirtual component */}
          <Box
            sx={{
              width: "32px",
              height: "32px",
              background:
                `linear-gradient(102deg, var(--baselayer-colors-pink-500, #C1276E) -29.68%,
                 #705AE5 18.85%, #2571F5 55.09%, var(--baselayer-colors-blue-500, #1840EC) 119.56%)`,
              borderRadius: "0.25rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            data-testid="tp-logo-virtual"
          >
            <IconButton
              href={tpVirtualUrl}
              rel="noopener noreferrer"
              target="_blank"
              aria-label="TrainingPeaks Virtual"
            >
              <TrainingpeaksVirtual
                size="24"
                fill={tpTheme.semanticLayer.colors.primary.contrastText}
                fillText={tpTheme.semanticLayer.colors.primary.contrastText}
              />
            </IconButton>
          </Box>
        </div>
      </div>
    </AppBar>
  );
};

export default Header;
